import { PublicationUpdateRequest } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import {
  useInvalidatePublicationQueries,
  useUpdatePublicationQueries,
} from "@/queries/query-publication";

export const useEditPublication = () => {
  const updatePublicationQuery = useUpdatePublicationQueries();
  const invalidatePublicationQueries = useInvalidatePublicationQueries();
  return useMutationWithErrorHandler<
    undefined,
    ApiError,
    {
      publicationId: string;
      publicationUpdate: PublicationUpdateRequest["publicationUpdate"];
    }
  >(async ({ publicationId, publicationUpdate }) => {
    const response = await getRanaApiV1().PublicationsApi.publicationUpdate({
      publicationId,
      publicationUpdate,
    });

    if (response) {
      updatePublicationQuery(publicationId, response);
    } else {
      await invalidatePublicationQueries(publicationId);
    }
  });
};
